/*
  Para incluir novas paginas no side bar existem alguns passos :
  10 - Definir a rota principal em router/index.js
  20 - Definir a rota de navegação em /admin/app-sidebar/NavigationRoutes.js.
  30 - Definir quais privilegios serão necessarios para acessar essa pagina e adiciona-los no /utils/privilegios.js
  40 - adicionar a rota em /admin/app-sidebar/AppSidebar.vue em dicioPriv e definir o metodo de validação de privilegios.
  50 - dentro do Sp360 em gerenciamento -> privilegios, criar o privilegio no backend.
  60 - dentro do Sp360 em gerenciamento -> perfis, adicionar o privileigio aos perfis pertinentes.
*/

import AuthLayout from '../components/auth/AuthLayout'
import AppLayout from '../components/admin/AppLayout'
import Router from 'vue-router'

function existe(el) {
  return typeof el !== 'undefined' && el != null
}

function getCaminhoArquivo(path, complemento){
  return path.replace('@/components/'+complemento,'').replace('.vue','');
}

function parseRouterNode(node) {
  let schemaRouter = ['path', 'redirect', 'component', 'children', 'metaRoute', 'name', 'props',
'default', 'components', 'alias']

  let routerNode = null
  if(existe(node[schemaRouter[0]]) && (existe(node[schemaRouter[1]]) || (existe(node[schemaRouter[2]]) && existe(node[schemaRouter[5]])))) {
    routerNode = {}
    //Adicionado para o analytics - default para contemplar o mainDashboard
    if(existe(node["displayName"]) || existe(node["default"])){
        mapaRotasInformacoes[node["path"]] = {"name": node["name"], "displayName": node["displayName"], "component": node["component"]}
    }
      schemaRouter.forEach(attr => {
          if(existe(node[attr])) {
              if(attr === 'metaRoute') {
                routerNode['meta'] = node[attr]
              } else if(attr === 'children') {
                  let child_nodes = []
                  let parsed_child = {}
                  node[attr].forEach(child => {
                      parsed_child = parseRouterNode(child)
                      if(existe(parsed_child)) {
                          child_nodes.push(parsed_child)
                      }
                  })
                  routerNode[attr] = child_nodes
              } else if(attr === 'component') {
                  if(node[attr] === 'AuthLayout') {
                    routerNode[attr] = AuthLayout
                  } else if(node[attr] === 'AppLayout') {
                    routerNode[attr] = AppLayout
                  } else if (node[attr] === 'EmptyParentComponent') {
                    routerNode[attr] = {template: '<router-view></router-view>'}
                  } else if (node[attr].includes('/auth/')){
                    routerNode[attr] = () => import(`../components/auth/${getCaminhoArquivo(node[attr], 'auth/')}.vue`)
                  } else if (node[attr].includes('/iframe/')){
                    routerNode[attr] = () => import(`../components/iframe/${getCaminhoArquivo(node[attr], 'iframe/')}.vue`)
                  } else if (node[attr].includes('/management/')){
                    routerNode[attr] = () => import(`../components/management/${getCaminhoArquivo(node[attr], 'management/')}.vue`)
                  } else if (node[attr].includes('/pages/')){
                    routerNode[attr] = () => import(`../components/pages/${getCaminhoArquivo(node[attr], 'pages/')}.vue`)
                  } else {
                    routerNode[attr] = () => import(`../components/dashboard/${getCaminhoArquivo(node[attr], 'dashboard/')}.vue`)
                  }
              } else if(attr === 'props') {
                routerNode[attr] = eval(node[attr])
              } else {
                routerNode[attr] = node[attr]
              }
          }
      })
  }
  
  return routerNode
}

export var router = null
export var mapaRotasInformacoes = []
export function gerarRouter(rotas) {
  
  let parsedNode = {}
  let routerModel = []
  
  rotas.routes.forEach(node => {
    parsedNode = parseRouterNode(node)
    if(existe(parsedNode)) {
      routerModel.push(parsedNode)
    }
  })

  router = new Router({
    mode: 'history',
    hash: false,
    routes: routerModel
  })

  return router
}